{
  "header": {
    "title": "Organisationsverwaltung",
    "not_registered": "Nicht angegeben",
    "tab_users": "Benutzer",
    "tab_departments": "Abteilungen"
  },
  "users": {
    "action_add": {
      "success": "Benutzer wurde eingeladen",
      "label": "Benutzer einladen",
      "title": "Benutzer einladen",
      "forbidden": "Unzureichende Berechtigungen",
      "not_found": "Benutzer wurde nicht gefunden",
      "already_invited": "Benutzer wurde bereits eingeladen",
      "already_organization_member": "Benutzer ist bereits Mitglied der Organisation",
      "form_action_Submit": "Einladen",
      "action_label": "{{count}} Benutzer einladen",
      "action_label_plural": "{{count}} Benutzer einladen",
      "invite_by_email": "E-Mail-Adresse eingeben"
    },
    "action_update_role": {
      "success": "Benutzerrolle wurde geändert",
      "tooltip": "Benutzer editieren",
      "title": "Benutzerrolle ändern",
      "content_text": "Sie bearbeiten {{email}}",
      "role_label": "Rolle",
      "forbidden": "Unzureichende Berechtigungen",
      "not_found": "Benutzer wurde nicht gefunden",
      "role_already_assigned": "Benutzer hat bereits diese Rolle",
      "no_owners_left": "Keine Besitzer übrig",
      "validation_role": "Wählen Sie eine Benutzerrolle aus"
    },
    "action_delete": {
      "success": "Benutzer wurde entfernt",
      "tooltip": "Benutzer entfernen",
      "title": "Benutzer entfernen",
      "content_text": "Sind Sie sicher das Sie {{email}} aus der Organisation entfernen möchten?",
      "error_forbidden": "Unzureichende Berechtigungen",
      "error_not_found": "Benutzer wurde nicht gefunden",
      "error_no_owners_left": "Keine Besitzer übrig",
      "form_action_Submit": "Entfernen"
    },
    "action_resolve_invite": {
      "success": "Einladung angenommen",
      "tooltip": "Einladung annehmen/ablehnen",
      "title": "Offene Einladungen",
      "content_text": "Einladung von ",
      "content_text_Accept": "Sind Sie sicher, dass Sie der Organisation beitreten wollen?",
      "content_text_Reject": "Sind Sie sicher, dass Sie die Einladung ablehnen wollen?",
      "error_not_found": "Benutzer wurde nicht gefunden",
      "error_submit": "Ein Fehler ist aufgetreten",
      "form_accept_action": "Annehmen",
      "form_dismiss_action": "Ablehnen"
    }
  },
  "management": {
    "manage_organization": "Organisation bearbeiten",
    "details_tab": "Einzelheiten",
    "departments_tab": "Abteilung",
    "projects_tab": "Projekte",
    "clusters_tab": "Cluster",
    "members_tab": "Mitglieder",
    "teams_tab": "Teams",
    "sso_tab": "SSO",
    "details_section": {
      "general_title": "Allgemein",
      "location_title": "Standort",
      "unsaved_form_question": "Ihre Änderungen sind nicht gespeichert, sind Sie sicher?"
    },
    "projects_list": {
      "title_projects": "Projekte",
      "title_services": "Services",
      "title_department": "Abteilung",
      "title_created": "Datum erstellt",
      "no_projects": "Es gibt keine Projekte",
      "create": "+ Erstellen"
    },
    "clusters_list": {
      "title_cluster": "Cluster",
      "title_service": "Service",
      "title_status": "Status",
      "title_project": "Projekt",
      "no_clusters": "Es gibt keine Cluster",
      "create": "+ Erstellen",
      "choose_cluster": "Welchen Cluster möchten Sie erstellen?"
    },
    "members_list": {
      "you": "Sie",
      "title_members": "Mitglieder",
      "title_role": "Rolle",
      "title_authentication": "Authentifizierung",
      "add": "+ Mitglieder einladen",
      "title_invited": "Eingeladen",
      "title_expires_in": "Läuft ab in",
      "no_invited_users": "Es gibt keine ausstehenden Einladungen.",
      "no_members": "Es gibt keine Mitglieder",
      "modal_title": "Mitglieder einladen",
      "cancel_invite": "Abbrechen",
      "expires_status_permanent": "Permanent",
      "authentication": {
        "basic_auth": "Benutzername & Passwort",
        "oauth2": "OAuth 2.0",
        "oidc": "OIDC",
        "part_of_sso_groups": "Dieser Benutzer ist Mitglied der folgenden SSO-Gruppen:"
      }
    }
  },
  "organizations": {
    "action_delete_thumbnail": {
      "content_text": "Sind Sie sicher, dass Sie den Thumbnail der Organisation löschen möchten?"
    }
  },
  "departments": {
    "projects": "Projekt",
    "projects_plural": "Projekte",
    "no_projects": "Keine Projekte vorhanden",
    "your_projects": "Ihre Projekte",
    "action_add": {
      "success": "Abteilung wurde erfolgreich erstellt",
      "label": "Abteilung hinzufügen",
      "title": "Abteilung hinzufügen",
      "error_not_found": "Organisation wurde nicht gefunden",
      "error_duplicate_name": "Abteilungsname ist bereits vorhanden",
      "form_action_create": "Erstellen"
    },
    "action_edit": {
      "success": "Abteilung wurde erfolgreich bearbeitet",
      "tooltip": "Abteilung bearbeiten"
    },
    "action_delete": {
      "success": "Abteilung wurde gelöscht",
      "tooltip": "Abteilung löschen"
    },
    "action_delete_thumbnail": {
      "content_text": "Sind Sie sicher, dass Sie den Thumbnail der Abteilung löschen möchten?"
    },
    "products": {
      "total": "Total",
      "up": "Up",
      "down": "Down",
      "no_products_in_department": "Diese Abteilung hat keine Produkte.",
      "no_products_in_project": "Dieses Projekt hat keine Produkte.",
      "no_products_in_organization": "Diese Organisation hat keine Produkte."
    },
    "management": {
      "manage_department": "Abteilungsverwaltung",
      "projects_tab": "Projekte",
      "clusters_tab": "Cluster",
      "members_tab": "Mitglieder",
      "projects_list": {
        "title_projects": "Projekt",
        "title_author": "Erstellt von",
        "title_created": "Erstellt am",
        "no_projects": "Es gibt keine Projekte",
        "create": "+ Erstellen"
      },
      "clusters_list": {
        "title_cluster": "Cluster",
        "title_status": "Status",
        "title_project": "Projekt",
        "no_clusters": "Es gibt keine Cluster"
      },
      "members_list": {
        "you": "Sie",
        "title_member": "Mitglieder",
        "no_members": "Es gibt keine Mitglieder",
        "add": "+ Mitglieder hinzufügen",
        "form": {
          "empty_list": "Member list is empty",
          "search": {
            "no_results": "Nothing was found"
          }
        }
      }
    }
  },
  "projects": {
    "action_delete_thumbnail": {
      "content_text": "Sind Sie sicher, dass Sie den Thumbnail des Projekts löschen möchten?"
    },
    "management": {
      "manage_project": "Projektleitung",
      "clusters_tab": "Cluster",
      "members_tab": "Mitglieder",
      "clusters_list": {
        "title_cluster": "Cluster",
        "title_type": "Service",
        "title_status": "Status",
        "no_clusters": "Es gibt keine Cluster"
      },
      "members_list": {
        "title_members": "Mitglieder",
        "you": "Sie",
        "no_members": "Dieses Projekt hat noch keine Mitglieder.",
        "form": {
          "empty_list": "Mitgliederliste ist leer",
          "search": {
            "no_results": "Es wurde nichts gefunden"
          }
        }
      }
    }
  },
  "teams": {
    "add_team": "Team erstellen",
    "add_members": "Mitglieder hinzufügen",
    "add_groups": "Gruppen hinzufügen",
    "sso_group": "SSO Gruppe",
    "remove_member_part1": "Wollen Sie ",
    "remove_member_part2": " wirklich aus dem Team entfernen?",
    "remove_team_part1": "Wollen Sie das Team ",
    "remove_team_part2": " wirklich entfernen?",
    "remove_team_can_not_be_undone": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "add_members_modal": {
      "submit": "{{count}} Mitglied hinzufügen",
      "submit_plural": "{{count}} Mitglieder hinzufügen",
      "no_possible_members": "Alle Nutzer der Organisation sind bereits ein Mitglied dieses Teams.",
      "no_search_results": "Ihre Suche ergab keine Treffer."
    },
    "add_groups_modal": {
      "search_or_add": "Suchen oder hinzufügen...",
      "submit": "{{count}} Gruppe hinzufügen",
      "submit_plural": "{{count}} Gruppen hinzufügen",
      "no_possible_groups": "Alle bekannten Gruppen sind bereits in diesem Team. Um eine benutzerdefinierte Gruppe hinzufügen, benutze das obrige Eingabefeld.",
      "no_search_results": "Ihre Suceh ergab keine Treffer. Um eine benutzerdefinierte Gruppe hinzufügen, drücke Enter oder klicke das Plus-Icon.",
      "errors": {
        "already_exists": "Diese Gruppe existiert bereits.",
        "already_member": "Diese Gruppe ist bereits Teil des Teams."
      }
    },
    "table": {
      "number_of_teams": "{{count}} Team",
      "number_of_teams_plural": "{{count}} Teams",
      "number_of_members": "{{count}} Mitglied",
      "number_of_members_plural": "{{count}} Mitglieder",
      "no_teams": "Diese Organisation hat noch keine Teams.",
      "no_members": "Dieses Team hat noch keine Mitglieder."
    },
    "properties": {
      "identifier": {
        "title": "Identifier",
        "immutable": "Der Identifier darf nicht geändert werden.",
        "errors": {
          "required": "Der Identifier darf nicht leer sein.",
          "regex": "Der Identifier darf nur Kleinbuchstaben, - und _ enthalten."
        }
      },
      "displayName": {
        "title": "Anzeigename",
        "errors": {
          "required": "Der Anzeigename darf nicht leer sein.",
          "regex": "Der Anzeigename darf nur Buchstaben, Leerzeichen, - und _ enthalten."
        }
      },
      "about": {
        "title": "Beschreibung",
        "empty_placeholder": "Dieses Team hat keine Beschreibung."
      },
      "role": {
        "title": "Rolle"
      }
    }
  },
  "oidc": {
    "status": {
      "label": "Single Sign-On ist derzeit <status>{{status}}</status>",
      "active": "aktiv",
      "inactive": "inaktiv",
      "actions": {
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren",
        "confirm": "Sind Sie sicher, dass Sie Single Sign-On für Ihre Organisation {{action}} möchten?"
      }
    },
    "hint": {
      "main": "Um SSO für Scalefield zu konfigurieren, stellen Sie sicher, dass die Routen korrekt festgelegt sind:",
      "login_url": "Verwenden Sie <b>{{url}}</b> als <b>Root-URL</b>",
      "callback_url": "Verwenden Sie <b>{{url}}</b> als <b>Redirect-URI</b>"
    },
    "teamMappingInfo": {
      "nothingSetUp": "Es sieht so aus, als hätten Sie noch keine Teams für die SSO-Integration konfiguriert.",
      "currentBehaviour": "Derzeit werden Benutzer, die sich über Ihren Identity Provider anmelden, als einfache Organisationsmitglieder hinzugefügt und haben keinen Zugriff auf Projekte.",
      "listCTA": "So aktivieren Sie die automatische Teamzuweisung und vereinfachen die Benutzerregistrierung:",
      "listStep1": "Stellen Sie sicher, dass Ihr Identity Provider Benutzergruppen im Token übermittelt, der an Scalefield gesendet wird.",
      "listStep2": "Legen Sie den Namen des Gruppen-Claims so fest, dass er dem Attribut für Gruppeninformationen Ihres Identity Providers entspricht.",
      "listStep3": "Erstellen Sie ein Team in Scalefield und fügen Sie die entsprechenden SSO-Gruppen als Mitglieder hinzu.",
      "afterBehaviour": "Benutzer in diesen Gruppen werden beim Login automatisch den entsprechenden Teams zugewiesen und übernehmen deren Berechtigungen."
    },
    "properties": {
      "issuerUrl": {
        "title": "Issuer URL",
        "hint": "Die Basis-URL Ihres OpenID-Providers. Dies muss die URL sein, unter der <b>/.well-known/openid-configuration</b> erreichbar ist (z. B. <b>https://accounts.example.com/realms/internal</b>)",
        "success": "Die angegebene URL ist gültig.",
        "error": "Die angegebene URL enthält keine gültige OpenID-Connect-Konfiguration. Stellen Sie sicher, dass <b>/.well-known/openid-configuration</b> erreichbar und korrekt eingerichtet ist."
      },
      "clientId": {
        "title": "Client ID",
        "hint": "Die eindeutige Kennung, die Scalefield innerhalb Ihres OpenID-Providers zugewiesen wurde"
      },
      "clientSecret": {
        "title": "Client Secret",
        "hint": "Ein geheimer Schlüssel, der von Ihrem OpenID-Provider ausgegeben wird und zur Authentifizierung von Scalefield verwendet wird"
      },
      "verifyCertificate": {
        "title": "Zertifikate verifizieren",
        "hint": "Deaktivieren Sie diese Option nur, wenn Ihr Provider keine sichere Kommunikation anbieten kann (z.B. Erzwingen von HTTPS und Überprüfung von TLS-Zertifikaten)"
      },
      "groupAttribute": {
        "title": "Group Claim Name",
        "hint": "Der Name des Attributs, in dem der Identity Provider die Gruppen angibt, zu denen der Benutzer gehört"
      },
      "domains": {
        "title": "Zugehörige Domains",
        "hint": "Eine Liste von E-Mail-Domains (der Teil nach <b>@</b>, z.B. <b>example.com</b>), die diese OIDC-Konfiguration verwenden sollen. Wenn sich ein Benutzer anmeldet, wird seine E-Mail-Domain abgeglichen, um den richtigen OIDC-Provider zu bestimmen",
        "field": "Domain",
        "actions": {
          "add": "Domain hinzufügen",
          "remove": "Domain entfernen"
        }
      }
    }
  },
  "department_selected": "{{count}} Abteilung ausgewählt",
  "department_selected_plural": "{{count}} Abteilungen ausgewählt",
  "project_selected": "{{count}} Projekt ausgewählt",
  "project_selected_plural": "{{count}} Projekte ausgewählt",
  "cluster_selected": "{{count}} Cluster ausgewählt",
  "cluster_selected_plural": "{{count}} Ausgewählte Cluster"
}
